import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { useAccountTopCard } from '@americanexpress/consumer-travel-base';
import { locales } from '@americanexpress/conditional-features';

export const useTopCardAccount = () => {
  const locale = useSelector(getActiveLocaleSelector);
  const { topCardAccount, isLoading } = useAccountTopCard({
    defer: locale !== locales.EN_US,
  });

  return {
    topCardAccount,
    isLoading,
  };
};
